export default "__VITE_ASSET__CKdX2Xfu__"